import axios from 'src/store/vue-axios/axios.js'

export default class Auth {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // AUTH -> /auth/*
  static authLoginUrl = (isNative) => `auth/login${isNative ? '?is_native=true' : ''}`
  static authLoginIdmUrl = (isNative) => `auth/login-idm${isNative ? '?is_native=true' : ''}`
  static authRefreshUrl = (isNative) => `auth/refresh${isNative ? '?is_native=true' : ''}`

  // AUTH -> /auth/password-reset*
  static authPasswordResetUrl = () => '/auth/password-reset'
  static authPasswordResetConfirmUrl = () => '/auth/password-reset/confirm'

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // AUTH -> /auth/*
  static async postAuthLogin (payload, config, isNative) {
    return axios.post(this.authLoginUrl(isNative), payload, config)
  }

  static async postAuthLoginIdm (payload, config, isNative) {
    return axios.post(this.authLoginIdmUrl(isNative), payload, config)
  }

  static async postAuthRefresh (payload, config, isNative) {
    return axios.post(this.authRefreshUrl(isNative), payload, config)
  }

  // AUTH -> /auth/password-reset*
  static async postAuthPasswordReset (payload) {
    return axios.post(this.authPasswordResetUrl(), payload)
  }

  static async postAuthPasswordResetConfirm (payload) {
    return axios.post(this.authPasswordResetConfirmUrl(), payload)
  }
}
